import { DESKTOP_PAGE_HEADER_CLASS } from '../layout/mobileLayoutConstants';

export function SettingsSubPageLayout({
  section,
  title,
  subtitle,
  children,
  footer,
  desktopTitle,
  desktopSubtitle,
}) {
  return (
    <div className="mx-auto flex min-h-0 max-w-2xl flex-col pb-24 md:pb-8">
      <header className={DESKTOP_PAGE_HEADER_CLASS}>
        <p className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground/80 md:hidden">
          {section}
        </p>
        <h1 className="mt-1 font-display text-2xl font-bold tracking-tight text-foreground md:mt-0 md:text-2xl md:font-semibold">
          {desktopTitle || title}
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground md:mt-1">
          {desktopSubtitle || subtitle}
        </p>
      </header>

      <div className="mt-4 flex-1 space-y-4 md:mt-6">{children}</div>

      {footer ? (
        <div className="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-card p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] md:static md:z-auto md:mt-6 md:border-0 md:bg-transparent md:p-0">
          {footer}
        </div>
      ) : null}
    </div>
  );
}
